import { render } from "./PersonalForm.vue?vue&type=template&id=8614dede"
import script from "./PersonalForm.vue?vue&type=script&lang=ts"
export * from "./PersonalForm.vue?vue&type=script&lang=ts"
script.render = render

export default script